// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__circleBase___sT3nF {
    stroke: #d1d3d7
}

.style__circleProgress___bGwO9 {
    stroke: var(--primary-color)
}
`, "",{"version":3,"sources":["webpack://./src/components/CircleProgress/style.css"],"names":[],"mappings":"AAAA;IACI;AACJ;;AAEA;IACI;AACJ","sourcesContent":[".circleBase {\n    stroke: #d1d3d7\n}\n\n.circleProgress {\n    stroke: var(--primary-color)\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"circleBase": `style__circleBase___sT3nF`,
	"circleProgress": `style__circleProgress___bGwO9`
};
export default ___CSS_LOADER_EXPORT___;
